import { render, staticRenderFns } from "./ConfigContainerTypeDialog.vue?vue&type=template&id=391d96b8&scoped=true"
import script from "./ConfigContainerTypeDialog.vue?vue&type=script&lang=ts"
export * from "./ConfigContainerTypeDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfigContainerTypeDialog.vue?vue&type=style&index=0&id=391d96b8&prod&scoped=true&lang=scss"
import style1 from "./ConfigContainerTypeDialog.vue?vue&type=style&index=1&id=391d96b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391d96b8",
  null
  
)

export default component.exports